// Generated by CoffeeScript 1.12.7
var getto, packagingTraits,
  slice = [].slice,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

getto = require('getto');

packagingTraits = {
  traitTypes: ['size', 'storageType', 'specialHandling', 'packDry'],
  sizes: ['tiny', 'extrasmall', 'small', 'medium', 'large', 'extralarge', 'oddsized', 'fullsized'],
  storageTypes: ['frozen', 'chill', 'dry', 'produce', 'flowers', 'virtual'],
  specialHandling: ['pickDuringPack', 'lastMinutePick', 'packByRoute'],
  orderingUnits: ['bag', 'bin', 'bucket', 'bunch', 'case', 'dozen', 'each', 'flat', 'half case', 'half dozen', 'lb'],
  comparisonUnits: ['lb', 'oz', 'fl oz', 'quart', 'gallon', 'ml', 'liter', 'serving'],
  packagingFormats: ['clamshell', 'tote', 'bag', 'bar', 'bottle', 'box', 'bunch', 'container', 'cup', 'disk', 'head', 'jar', 'package', 'pint']
};

packagingTraits.all = [].concat(packagingTraits.sizes, packagingTraits.storageTypes, packagingTraits.specialHandling);

packagingTraits.hasColdPacks = function() {
  var products;
  products = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (products[0] instanceof Array) {
    products = products[0];
  }
  return products.some(function(product) {
    var i, len, trait, traits;
    traits = packagingTraits.getTraitsFor(product);
    for (i = 0, len = traits.length; i < len; i++) {
      trait = traits[i];
      if (trait === 'packDry' || trait === 'lastMinutePick' || trait === 'packByRoute' || trait === 'oddsized' || trait === 'fullsized') {
        return false;
      }
    }
    return indexOf.call(traits, 'frozen') >= 0 || indexOf.call(traits, 'chill') >= 0;
  });
};

packagingTraits.isLastMinutePick = function(product) {
  var i, len, trait, traits;
  traits = packagingTraits.getTraitsFor(product);
  for (i = 0, len = traits.length; i < len; i++) {
    trait = traits[i];
    if (trait === 'flowers' || trait === 'lastMinutePick' || trait === 'packByRoute' || trait === 'oddsized' || trait === 'fullsized') {
      return true;
    }
  }
  return false;
};

packagingTraits.getTraitsFor = function(model) {
  var i, key, len, ref, traits, value;
  getto(model);
  traits = [];
  ref = packagingTraits.traitTypes;
  for (i = 0, len = ref.length; i < len; i++) {
    key = ref[i];
    value = model.get(key);
    if (value && key === 'packDry') {
      value = 'packDry';
    }
    if (value) {
      traits.push(value);
    }
  }
  return traits;
};

module.exports = packagingTraits;
